





















































































































































































































































































































































































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import uniq from 'lodash/uniq';
import OfficeScheduleForm from './OfficeScheduleForm/OfficeScheduleForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',
      'loading_year', 'loaded_year', 'fatalError_year',

      'filter', 'delivery_zone', 'days_data', 'documents_by_dates',
      'col_days',

      'documents', 'lastMeta', 'holydays', 'year', 'months'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'exportData'
    ])
  },
  components: {
    TitleBar
  }
})
export default class DeliveryDatesManager extends Vue {
  // radioButton = 1;
  // open = false

  opened: any[] = [];
  by_day_opened: any[] = [];
  allZones: boolean = false;
  activeDetailTab: number = 0;

  get titleStack () {
    return [
      'Доставка', 'Управление датами доставки'
    ]
  }

  onMouse(day: any, action: string) {
    console.log(day, action);
    day.icon = action == 'over'
  }

  setDeliveryPoints(points: any[]) {
    this.$store.dispatch(`${STORE_KEY}/setDeliveryPoints`, points)
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  onDetailByDatesToggle(row: any, to: string) {
    if (to == 'open') {
      this.by_day_opened = uniq([
        ...this.by_day_opened,
        row.id
      ]);
    } else {
      this.by_day_opened = uniq(
        this.by_day_opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: OfficeScheduleForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {
          delivery_zone_id: row.delivery_zone_id
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  deleteOfficeSchedule(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить выбранный графки работы?`,
      confirmText: 'Удалить', 
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/removeSchedule`, row)
        .then((result) => {
          this.$buefy.snackbar.open(`Запись удалена`);
          this.handleParamsChange();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }


  // ---------------------------------------------------------------------------

  // saveZone(row: any) {
  // }

  cancelSave(index: number, idx: number) {
    this.$store.dispatch(`${STORE_KEY}/cancelSave`, {index, idx});
  }

  saveZone(index: number, idx: number) {
    this.$store.dispatch(`${STORE_KEY}/saveZone`, {index, idx});
  }

  savePoint(index: number, idx: number, point_idx: number) {
    this.$store.dispatch(`${STORE_KEY}/savePoint`, {index, idx, point_idx});
  }
  
  cancelPointSave(index: number, idx: number, point_idx: number) {
    this.$store.dispatch(`${STORE_KEY}/cancelPointSave`, {index, idx, point_idx});
  }

  setValue(index: number, idx: number, day_idx: number, field: string, newValue: any) {
    this.$store.dispatch(`${STORE_KEY}/setValue`, {index, idx, day_idx, field, newValue});
  }

  setPointValue(index: number, idx: number, point_idx: number, day_idx: number, field: string, newValue: any) {
    this.$store.dispatch(`${STORE_KEY}/setPointValue`, {index, idx, point_idx, day_idx, field, newValue});
  }

  changeHolyday(month: any, $event: any[]) {
    this.$store.dispatch(`${STORE_KEY}/setHolydays`, {month, newValue: $event, allZones: this.allZones});
  }

  setComment(comment: string, zone_id: any, point_id: any, day: any) {
    this.$buefy.dialog.prompt({
      message: `Комментарий`,
      inputAttrs: {
          placeholder: 'Укажите комментарий',
          value: comment,
      },
      confirmText: 'Сохранить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/setComment`, {comment: value, zone_id, point_id, day});
      }
    })
    console.log(zone_id, point_id, day)
  }

  changeTab(tab: any) {
    if (tab == 1) {
      this.setYear(null, null, null, false)
    }
    this.$router.replace({
      query: {
        ...this.$route.query,
        // @ts-ignore
        tab,
      }
    })  
  }

  setByDates(range: any) {
    console.log(range);
    this.$store.dispatch(`${STORE_KEY}/loadDataByDates`, {from: range[0], to: range[1]});

  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.activeDetailTab = this.$route.query.tab ? parseInt(this.$route.query.tab as any) : 0
    this.handleParamsChange();
  }

  public setYear(year: any, delivery_zone: any, delivery_point: any, allZones: boolean) {
    this.$store.dispatch(`${STORE_KEY}/setYear`, {newValue: year, delivery_zone, delivery_point, allZones});
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
